export const trimText = (value, length = 250) => {
  return value.length > length ? value.substring(0, length - 3) + '...' : value;
};
